import { t } from "i18next"
import {
  BASE_NO_SPECIALTY,
  BASE_NO_TIME_TO_TREAT,
  baseSchema,
} from "@/modules/patients/detail/progress-note/point-of-care/schema/base-schema"

export const DePointOfCareSchema = baseSchema.superRefine((data, ctx) => {
  const activePointOfCare = data.actualPointOfCare ?? data.medicalPointOfCare
  if (activePointOfCare) {
    if (!BASE_NO_SPECIALTY.includes(activePointOfCare) && !data.specialtyId && !data.betterDocSuggestionStatus) {
      // Adds error that makes specialty required
      ctx.addIssue({
        code: "custom",
        message: t("common.fieldErrorList.requiredField"),
        path: ["specialtyId"],
      })
    }
    if (!BASE_NO_TIME_TO_TREAT.includes(activePointOfCare) && !data.timeToTreatType) {
      // Adds error that makes timeToTreatType required
      ctx.addIssue({
        code: "custom",
        message: t("common.fieldErrorList.requiredField"),
        path: ["timeToTreatType"],
      })
    }
  }
  if (data.medicalPointOfCare && data.actualPointOfCare && !data.reasonForChoosingType) {
    // Adds error that makes reasonForChoosingType required, if actualPointOfCare has value
    ctx.addIssue({
      code: "custom",
      message: t("common.fieldErrorList.requiredField"),
      path: ["reasonForChoosingType"],
    })
  }
})
